import React from 'react'

import { Refine, AuthProvider } from '@pankod/refine-core'
import {
  notificationProvider,
  RefineSnackbarProvider,
  CssBaseline,
  GlobalStyles,
  ReadyPage,
  ErrorComponent,
} from '@pankod/refine-mui'

import dataProvider from '@pankod/refine-simple-rest'
import { MuiInferencer } from '@pankod/refine-inferencer/mui'
import routerProvider from '@pankod/refine-react-router-v6'
import axios, { AxiosRequestConfig } from 'axios'
import { ColorModeContextProvider } from 'contexts'
import { Title, Sider, Layout, Header } from 'components/layout'
import { parseJwt } from 'utils/parse-jwt'
import {
  AccountCircleOutlined,
  ChatBubbleOutline,
  PeopleAltOutlined,
  StarOutlineRounded,
  VillaOutlined,
} from '@mui/icons-material'

import {
  Login,
  Home,
  Agents,
  MyProfile,
  PropertyDetails,
  AllProperties,
  CreateProperty,
  AgentProfile,
  EditProperty,
} from 'pages'

import { CredentialResponse } from 'interfaces/google'

const axiosInstance = axios.create()
axiosInstance.interceptors.request.use((request: AxiosRequestConfig) => {
  const token = localStorage.getItem('token')
  if (request.headers) {
    request.headers['Authorization'] = `Bearer ${token}`
  } else {
    request.headers = {
      Authorization: `Bearer ${token}`,
    }
  }

  return request
})

function App() {
  const authProvider: AuthProvider = {
    login: async ({ credential }: CredentialResponse) => {
      const profileObj = credential ? parseJwt(credential) : null

      if (profileObj) {
        const response = await fetch(
          // 'http://localhost:8080/api/v1/users',
          process.env.REACT_APP_API_URL + '/api/users',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name: profileObj.name,
              email: profileObj.email,
              avatar: profileObj.picture,
            }),
          }
        )

        const data = await response.json()

        if (response.status === 200) {
          localStorage.setItem(
            'user',
            JSON.stringify({
              ...profileObj,
              avatar: profileObj.picture,
              userid: data._id,
            })
          )
        } else {
          return Promise.reject()
        }
      }

      localStorage.setItem('token', `${credential}`)

      return Promise.resolve()
    },
    logout: () => {
      const token = localStorage.getItem('token')

      if (token && typeof window !== 'undefined') {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        axios.defaults.headers.common = {}
        window.google?.accounts.id.revoke(token, () => {
          return Promise.resolve()
        })
      }

      return Promise.resolve()
    },
    checkError: () => Promise.resolve(),
    checkAuth: async () => {
      const token = localStorage.getItem('token')

      if (token) {
        return Promise.resolve()
      }
      return Promise.reject()
    },

    getPermissions: () => Promise.resolve(),
    getUserIdentity: async () => {
      const user = localStorage.getItem('user')
      if (user) {
        return Promise.resolve(JSON.parse(user))
      }
    },
  }

  return (
    <ColorModeContextProvider>
      <CssBaseline />
      <GlobalStyles styles={{ html: { WebkitFontSmoothing: 'auto' } }} />
      <RefineSnackbarProvider>
        <Refine
          // dataProvider={dataProvider('https://api.fake-rest.refine.dev')}
          // dataProvider={dataProvider('http://localhost:3001/api')}
          dataProvider={dataProvider(
            (process.env.REACT_APP_API_URL as string) + '/api/'
          )}
          notificationProvider={notificationProvider}
          ReadyPage={ReadyPage}
          catchAll={<ErrorComponent />}
          resources={[
            // {
            //   name: 'posts',
            //   list: MuiInferencer,
            //   edit: MuiInferencer,
            //   show: MuiInferencer,
            //   create: MuiInferencer,
            //   canDelete: true,
            // },
            {
              name: 'properties',
              list: AllProperties,
              edit: EditProperty,
              show: PropertyDetails,
              create: CreateProperty,
              // canDelete: true,
              icon: <VillaOutlined />,
            },
            {
              name: 'agents',
              list: Agents,
              // edit: MuiInferencer,
              show: AgentProfile,
              // create: MuiInferencer,
              // canDelete: true,
              icon: <PeopleAltOutlined />,
            },
            {
              name: 'reviews',
              list: Home,
              // edit: MuiInferencer,
              // show: MuiInferencer,
              // create: MuiInferencer,
              // canDelete: true,
              icon: <StarOutlineRounded />,
            },
            {
              name: 'messages',
              list: Home,
              // edit: MuiInferencer,
              // show: MuiInferencer,
              // create: MuiInferencer,
              // canDelete: true,
              icon: <ChatBubbleOutline />,
            },
            {
              name: 'my-profile',
              options: { label: 'My profile' },
              list: MyProfile,
              // edit: MuiInferencer,
              // show: MuiInferencer,
              // create: MuiInferencer,
              // canDelete: true,
              icon: <AccountCircleOutlined />,
            },
          ]}
          Title={Title}
          Sider={Sider}
          Layout={Layout}
          Header={Header}
          routerProvider={routerProvider}
          authProvider={authProvider}
          LoginPage={Login}
          DashboardPage={Home}
        />
      </RefineSnackbarProvider>
    </ColorModeContextProvider>
  )
}

export default App
